import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Email from 'components/pages/Base/Email/Email';

const StyledNewEmailPage = styled(Email)`
  ${ComponentStyles}
`;

StyledNewEmailPage.propTypes = {
  theme: PropTypes.object
};

export default StyledNewEmailPage;
